import http from './httpService';

export function getAllBusinessLines() {
  return http.get(`/business-lines`);
}

export function createBusinessLine(payload) {
  return http.post(`/business-lines`, payload);
}

export function updateBusinessLine(payload) {
  return http.put(`/business-lines`, payload);
}

export function deleteBusinessLine(id) {
  return http.delete(`/business-lines/${id}`);
}
